import React, { useState, useEffect } from "react";
import {
  Container,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  TextField,
  Paper,
  Typography,
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Autocomplete,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
} from "@mui/material";
import { ArrowDropDown, Search } from "@mui/icons-material";
// import { serverUrl } from '../server';
import { getAxiosErrorMessage, getRequest, postRequest, server } from "../config";
import moment from "moment";
import MangerProfile from "../components/MangerProfile";
import { toast } from "react-toastify";

const ManagerList = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const [customers, setCustomers] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [selectedCity, setSelectedCity] = useState("");
  const [allCities, setallCities] = useState([]);
  const [backData, setbackData] = useState([]);
  const [actualValue, setactualValue] = useState({ name: "All Cities" });
  const [selectedManger, setselectedManger] = useState(null);
  const [openEdit, setOpenEdit] = useState(false);
  const [formData, setFormData] = useState({});
  useEffect(() => {
    fetchCustomers();
  }, [searchQuery, page, rowsPerPage, selectedCity]);

  // Fetch customers from the LoopBack backend with filter and pagination

  const fetchCities = async () => {
    try {
      const uri = server.uri + "cities";
      const citiesData = await getRequest(uri);
      if (citiesData) {
        setallCities(citiesData);
        setbackData(citiesData);
      }
    } catch (error) {}
  };
  useEffect(() => {
    fetchCities();
  }, []);

  const fetchCustomers = async () => {
    try {
      const filter = {
        where: {
          or: [
            { name: { like: `%${searchQuery}%` } },
            { email: { like: `%${searchQuery}%` } },
            { pincode: { like: `%${searchQuery}%` } },
          ],
        },
        skip: page * rowsPerPage,
        limit: rowsPerPage,
      };
      let cityid = "";
      if (selectedCity && selectedCity.length > 0) {
        cityid = `,"city":${selectedCity},`;
        console.log(cityid);
      }
      if (selectedCity) {
        const response = await getRequest(
          `${server.uri}users?filter={
        "where":{
        "or":[
        {"name":{"like":"${searchQuery}"}},
        {"mobileNumber":{"like":"${searchQuery}"}},
         {"pincode":{"like":"${searchQuery}"}}
        
      ],"userType":"manager","city":"${selectedCity}"},"skip":"${filter.skip}",
        "limit":"${filter.limit}"
        ,"order":"createdAt desc"}`
        );
        //   console.log(response);

        setCustomers(response);
        const responseCount = await getRequest(
          `${server.uri}users/count?where={
        
        "or":[
        {"name":{"like":"${searchQuery}"}},
        {"mobileNumber":{"like":"${searchQuery}"}},
         {"mobileNumber":{"like":"${searchQuery}"}}
      ],"userType":"manager","city":"${selectedCity}"}`
        );

        console.log(responseCount);

        setTotalCount(responseCount.count);
      } else {
        const response = await getRequest(
          `${server.uri}users?filter={
  "where": {
    "and": [
      {
        "or": [
          { "name": { "like": "${searchQuery}" } },
          { "mobileNumber": { "like": "${searchQuery}" } },
          { "servingPinCodes": { "like": "${searchQuery}" } }
        ]
      },
      {
        "or": [
          { "userType": "manager" },
          {
            "and": [
              { "userType": "partner" },
              { "servingPinCodes": { "neq": [] } },
              { "servingPinCodes": { "exists": true } }
            ]
          }
        ]
      }
    ]
  },
  "skip": "${filter.skip}",
  "limit": "${filter.limit}",
  "order": "createdAt desc"
}`
        );
        //   console.log(response);

        setCustomers(response);
        const responseCount = await getRequest(
          `${server.uri}users/count?where={
            
            "or":[
            {"name":{"like":"${searchQuery}"}},
            {"mobileNumber":{"like":"${searchQuery}"}},
             {"pincode":{"like":"${searchQuery}"}}
          ],"or":[{"userType":"manager"},{
        "or": [
          { "userType": "manager" },
          {
            "and": [
              { "userType": "partner" },
              { "servingPinCodes": { "neq": [] } },
              { "servingPinCodes": { "exists": true } }
            ]
          }
        ]
      }]}`
        );

        console.log(responseCount);

        setTotalCount(responseCount.count);
      }
    } catch (error) {
      console.error("Error fetching customers:", error);
    }
  };

  // Handle search query change
  const handleSearch = (event) => {
    setSearchQuery(event.target.value);
    setPage(0); // Reset to the first page when search changes
  };

  // Handle page change
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleUpdate = async () => {
    try {
      const user = await postRequest(`${server.uri}/users`, {
        name: formData.name,
        mobileNumber: formData.mobileNumber,
        city: formData.city,
        status: formData.status,
        servingPinCodes: formData.servingPinCodes,
        fullAddress: formData.fullAddress,
        userType: "manager",
        paymentTransactionId: formData?.isPaymentDone=='verified' ? formData.paymentTransactionId || null : null,
        registrationPaidAt: formData?.isPaymentDone=='verified'? new Date() : null,
      });
      if (user) {
        toast.success("Manager Created Successfully");
        await fetchCustomers()
      }

      setOpenEdit(false);
    } catch (err) {
      console.error(err);
      console.log(getAxiosErrorMessage(err));
      
      toast.error(getAxiosErrorMessage(err));
    }
  };

  // Handle rows per page change
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0); // Reset to the first page when rows per page changes
  };
  const handleChangeInput = (e) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };
  const handleCityChange = (event, value) => {
    setSelectedCity(value?.name);
    setactualValue(value);
    setPage(0); // Reset to the first page when city changes
  };

  const handleEditOpen = () => setOpenEdit(true);
  const handleEditClose = () => setOpenEdit(false);
  const cities = ["New York", "Los Angeles", "Chicago", "Houston", "Phoenix"]; // Example city list
  if (selectedManger) {
    return (
      <MangerProfile
        manager={selectedManger}
        onClose={() => setselectedManger(null)}
      />
    );
  }
  return (
    <Container>
      <Box
        sx={{ marginTop: 8, marginBottom: 2 }}
        className="flex items-center justify-between "
      >
        <Typography variant="h4" sx={{}}>
          Manager List
        </Typography>

        <Button
          onClick={handleEditOpen}
          type="button"
          variant="contained"
          color="primary"
        >
          Add Manager
        </Button>
      </Box>
      {/* Search Bar */}
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={2}
      >
        {/* Search Bar */}
        <TextField
          variant="outlined"
          placeholder="Search by name/mobile number/pincode"
          fullWidth
          value={searchQuery}
          onChange={handleSearch}
          InputProps={{
            startAdornment: <Search sx={{ color: "gray", marginRight: 1 }} />,
          }}
          sx={{ marginRight: 2 }}
        />

        {/* City Dropdown */}
        <FormControl variant="outlined" sx={{ minWidth: 200 }}>
          {/* <InputLabel>City</InputLabel> */}
          <Autocomplete
            value={actualValue}
            onChange={handleCityChange}
            // label="City"
            getOptionLabel={(option) => option?.name}
            options={allCities}
            fullWidth
            freeSolo
            renderInput={(params) => (
              <TextField
                onch
                {...params}
                label="Search City"
                variant="outlined"
                fullWidth
              />
            )}
            renderOption={(props, option) => (
              <MenuItem {...props} key={option?.cityId}>
                {option?.name}
              </MenuItem>
            )}
          />
        </FormControl>
      </Box>
      <Typography variant="subtitle1" sx={{ textAlign: "right" }} gutterBottom>
        Total Managers: <strong>{totalCount}</strong>
      </Typography>
      {/* Customer Table */}
      <Paper>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow
                sx={{
                  backgroundColor: "#f4f6f8", // Light background for table header
                }}
              >
                <TableCell sx={{ fontWeight: "bold" }}>Name</TableCell>

                <TableCell sx={{ fontWeight: "bold" }}>Phone</TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>City</TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>Pincode</TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>Status</TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>Payment</TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>Expiry</TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>Joined At</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {customers.map((customer) => (
                <TableRow
                  sx={{
                    "&:nth-of-type(even)": {
                      backgroundColor: "#f9fafb", // Alternate row color for better readability
                    },
                  }}
                  key={customer.userId}
                >
                  <TableCell onClick={() => setselectedManger(customer)}>
                    {customer?.name}
                  </TableCell>

                  <TableCell>{customer?.mobileNumber}</TableCell>
                  <TableCell>{customer?.city}</TableCell>
                  <TableCell>{customer?.servingPinCodes?.join(",")}</TableCell>
                  <TableCell>
                    <Box
                      sx={{
                        px: 1,
                        py: 0.5,
                        borderRadius: 1,
                        display: "inline-block",
                        bgcolor:
                          customer?.status === "verified"
                            ? "success.light"
                            : customer?.status === "pending"
                            ? "warning.light"
                            : customer?.status === "rejected"
                            ? "error.light"
                            : "grey.300",
                        color:
                          customer?.status === "verified"
                            ? "success.dark"
                            : customer?.status === "pending"
                            ? "warning.dark"
                            : customer?.status === "rejected"
                            ? "error.dark"
                            : "grey.700",
                        fontSize: "0.75rem",
                        fontWeight: "bold",
                        textTransform: "capitalize",
                      }}
                    >
                      {customer?.status || "unverified"}
                    </Box>
                  </TableCell>
                  <TableCell>
                    <Box
                      sx={{
                        px: 1,
                        py: 0.5,
                        borderRadius: 1,
                        display: "inline-block",
                        bgcolor: customer?.registrationPaidAt
                          ? "success.light"
                          : "error.light",
                        color: customer?.registrationPaidAt
                          ? "success.dark"
                          : "error.dark",
                        fontSize: "0.75rem",
                        fontWeight: "bold",
                      }}
                    >
                      {customer?.registrationPaidAt ? "Paid" : "Unpaid"}
                    </Box>
                  </TableCell>
                  <TableCell>
                    {customer?.registrationExpiresAt
                      ? moment(customer?.registrationExpiresAt).format("DD/MM/YYYY")
                      : "-"}
                  </TableCell>
                  <TableCell>
                    {moment(customer?.createdAt).startOf("hour").fromNow()}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>

        {/* Pagination */}
        <TablePagination
          rowsPerPageOptions={[5, 10, 25,100,200,500,1000]}
          component="div"
          count={totalCount}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Paper>
      <Dialog open={openEdit} onClose={handleEditClose}>
        <DialogTitle>Create Manger</DialogTitle>
        <DialogContent>
          <TextField
            fullWidth
            margin="dense"
            name="name"
            label="manager Name"
            value={formData.name || ""}
            onChange={handleChangeInput}
          />
          <TextField
            fullWidth
            margin="dense"
            name="mobileNumber"
            label="Mobile Number"
            value={formData.mobileNumber || ""}
            onChange={handleChangeInput}
          />
          <TextField
            fullWidth
            margin="dense"
            name="city"
            label="City"
            value={formData.city || ""}
            onChange={handleChangeInput}
          />
          <FormControl fullWidth margin="dense">
            <InputLabel id="status-label">Status</InputLabel>
            <Select
              labelId="status-label"
              name="status"
              value={formData.status || ""}
              onChange={handleChangeInput}
            >
              <MenuItem value="pending">Pending</MenuItem>
              <MenuItem value="verified">Approved</MenuItem>
              <MenuItem value="unverified">
                Rejected Due to Verification
              </MenuItem>
              <MenuItem value="rejected">Rejected Due to Other</MenuItem>
            </Select>
          </FormControl>
            <FormControl fullWidth margin="dense">
            <InputLabel id="status-label">Registration Payment Status</InputLabel>
            <Select
              labelId="status-label"
              name="isPaymentDone"
              value={formData.isPaymentDone || ""}
              onChange={handleChangeInput}
            >
              <MenuItem value="pending">Pending</MenuItem>
              <MenuItem value="verified">Paid</MenuItem>
            
            </Select>
          </FormControl>
          {formData.isPaymentDone === 'verified' && (
            <TextField
              fullWidth
              margin="dense"
              name="paymentTransactionId"
              label="Transaction ID"
              value={formData.paymentTransactionId || ""}
              onChange={handleChangeInput}
              placeholder="Enter payment transaction ID"
            />
          )}
          <Autocomplete
            multiple
            freeSolo
            options={[]}
            value={formData.servingPinCodes}
            onChange={(e, newValue) => {
              const validPincodes = newValue
                .map((p) => p.trim())
                .filter(
                  (p, index, self) =>
                    /^\d{1,6}$/.test(p) && self.indexOf(p) === index
                );
              setFormData({
                ...formData,
                servingPinCodes: validPincodes,
              });
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Pincodes"
                placeholder="Enter up to 6-digit pincodes"
                helperText="Only numeric values allowed (max 6 digits each)"
              />
            )}
          />
          {/* <TextField
            fullWidth
            margin="dense"
            name="pincode"
            label="Pin Code"
            value={formData.pincode || ""}
            onChange={handleChangeInput}
          /> */}
          <TextField
            fullWidth
            margin="dense"
            name="fullAddress"
            label="Address"
            value={formData.fullAddress || ""}
            onChange={handleChangeInput}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleEditClose}>Cancel</Button>
          <Button onClick={handleUpdate} variant="contained" color="primary">
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
};

export default ManagerList;
